export const GET_ACTIVE_SERVICES_REQUEST = "GET_ACTIVE_SERVICES_REQUEST";
export const GET_ACTIVE_SERVICES_SUCCESS = "GET_ACTIVE_SERVICES_SUCCESS";
export const GET_ACTIVE_SERVICES_FAILURE = "GET_ACTIVE_SERVICES_FAILURE";

// GPS Summary
export const GET_GPS_SUMMARY_REQUEST = "GET_GPS_SUMMARY_REQUEST";
export const GET_GPS_SUMMARY_SUCCESS = "GET_GPS_SUMMARY_SUCCESS";
export const GET_GPS_SUMMARY_FAILURE = "GET_GPS_SUMMARY_FAILURE";

// GPS Report
export const GET_GPS_REPORT_REQUEST = "GET_GPS_REPORT_REQUEST";
export const GET_GPS_REPORT_SUCCESS = "GET_GPS_REPORT_SUCCESS";
export const GET_GPS_REPORT_FAILURE = "GET_GPS_REPORT_FAILURE";

// GPS Substatus Table Report (filtered only for the table)
export const GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST = "GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST";
export const GET_GPS_SUBSTATUS_TABLE_REPORT_SUCCESS = "GET_GPS_SUBSTATUS_TABLE_REPORT_SUCCESS";
export const GET_GPS_SUBSTATUS_TABLE_REPORT_FAILURE = "GET_GPS_SUBSTATUS_TABLE_REPORT_FAILURE";

// Tickets Summary
export const GET_TICKETS_SUMMARY_REQUEST = "GET_TICKETS_SUMMARY_REQUEST";
export const GET_TICKETS_SUMMARY_SUCCESS = "GET_TICKETS_SUMMARY_SUCCESS";
export const GET_TICKETS_SUMMARY_FAILURE = "GET_TICKETS_SUMMARY_FAILURE";

// Tickets Summary Graph (independent state for graph filters)
export const GET_TICKETS_SUMMARY_GRAPH_REQUEST = "GET_TICKETS_SUMMARY_GRAPH_REQUEST";
export const GET_TICKETS_SUMMARY_GRAPH_SUCCESS = "GET_TICKETS_SUMMARY_GRAPH_SUCCESS";
export const GET_TICKETS_SUMMARY_GRAPH_FAILURE = "GET_TICKETS_SUMMARY_GRAPH_FAILURE";

// Simcards Report
export const GET_SIMCARDS_REPORT_REQUEST = "GET_SIMCARDS_REPORT_REQUEST";
export const GET_SIMCARDS_REPORT_SUCCESS = "GET_SIMCARDS_REPORT_SUCCESS";
export const GET_SIMCARDS_REPORT_FAILURE = "GET_SIMCARDS_REPORT_FAILURE";

// Simcards Report Filtered (for graph filters)
export const GET_SIMCARDS_REPORT_FILTERED_REQUEST = "GET_SIMCARDS_REPORT_FILTERED_REQUEST";
export const GET_SIMCARDS_REPORT_FILTERED_SUCCESS = "GET_SIMCARDS_REPORT_FILTERED_SUCCESS";
export const GET_SIMCARDS_REPORT_FILTERED_FAILURE = "GET_SIMCARDS_REPORT_FILTERED_FAILURE";

// Devices Report
export const GET_DEVICES_REPORT_REQUEST = "GET_DEVICES_REPORT_REQUEST";
export const GET_DEVICES_REPORT_SUCCESS = "GET_DEVICES_REPORT_SUCCESS";
export const GET_DEVICES_REPORT_FAILURE = "GET_DEVICES_REPORT_FAILURE";

// Devices Report Filtered (for graph filters)
export const GET_DEVICES_REPORT_FILTERED_REQUEST = "GET_DEVICES_REPORT_FILTERED_REQUEST";
export const GET_DEVICES_REPORT_FILTERED_SUCCESS = "GET_DEVICES_REPORT_FILTERED_SUCCESS";
export const GET_DEVICES_REPORT_FILTERED_FAILURE = "GET_DEVICES_REPORT_FILTERED_FAILURE";

// Agencies (for city selector)
export const GET_AGENCIES_REQUEST = "GET_AGENCIES_REQUEST";
export const GET_AGENCIES_SUCCESS = "GET_AGENCIES_SUCCESS";
export const GET_AGENCIES_FAILURE = "GET_AGENCIES_FAILURE";

// Companies (for company selector in reports)
export const GET_COMPANIES_REPORTS_REQUEST = "GET_COMPANIES_REPORTS_REQUEST";
export const GET_COMPANIES_REPORTS_SUCCESS = "GET_COMPANIES_REPORTS_SUCCESS";
export const GET_COMPANIES_REPORTS_FAILURE = "GET_COMPANIES_REPORTS_FAILURE";

// Export Actions
export const EXPORT_GPS_SUMMARY_REQUEST = "EXPORT_GPS_SUMMARY_REQUEST";
export const EXPORT_GPS_SUMMARY_SUCCESS = "EXPORT_GPS_SUMMARY_SUCCESS";
export const EXPORT_GPS_SUMMARY_FAILURE = "EXPORT_GPS_SUMMARY_FAILURE";

export const EXPORT_TICKETS_SUMMARY_REQUEST = "EXPORT_TICKETS_SUMMARY_REQUEST";
export const EXPORT_TICKETS_SUMMARY_SUCCESS = "EXPORT_TICKETS_SUMMARY_SUCCESS";
export const EXPORT_TICKETS_SUMMARY_FAILURE = "EXPORT_TICKETS_SUMMARY_FAILURE";

export const EXPORT_GPS_REPORT_REQUEST = "EXPORT_GPS_REPORT_REQUEST";
export const EXPORT_GPS_REPORT_SUCCESS = "EXPORT_GPS_REPORT_SUCCESS";
export const EXPORT_GPS_REPORT_FAILURE = "EXPORT_GPS_REPORT_FAILURE";

export const EXPORT_SIMCARDS_REPORT_REQUEST = "EXPORT_SIMCARDS_REPORT_REQUEST";
export const EXPORT_SIMCARDS_REPORT_SUCCESS = "EXPORT_SIMCARDS_REPORT_SUCCESS";
export const EXPORT_SIMCARDS_REPORT_FAILURE = "EXPORT_SIMCARDS_REPORT_FAILURE";

export const EXPORT_DEVICES_REPORT_REQUEST = "EXPORT_DEVICES_REPORT_REQUEST";
export const EXPORT_DEVICES_REPORT_SUCCESS = "EXPORT_DEVICES_REPORT_SUCCESS";
export const EXPORT_DEVICES_REPORT_FAILURE = "EXPORT_DEVICES_REPORT_FAILURE";

export const EXPORT_INVENTORY_REPORT_REQUEST = "EXPORT_INVENTORY_REPORT_REQUEST";
export const EXPORT_INVENTORY_REPORT_SUCCESS = "EXPORT_INVENTORY_REPORT_SUCCESS";
export const EXPORT_INVENTORY_REPORT_FAILURE = "EXPORT_INVENTORY_REPORT_FAILURE";

// Active Services Actions
export const getActiveServicesRequest = (filters = {}) => ({
    type: GET_ACTIVE_SERVICES_REQUEST,
    payload: {
        filters
    }
});

export const getActiveServicesSuccess = (activeservices, total) => ({
    type: GET_ACTIVE_SERVICES_SUCCESS,
    payload: {
        activeservices,
        total
    }
});

export const getActiveServicesFailure = err => ({
    type: GET_ACTIVE_SERVICES_FAILURE,
    error: err
});

// GPS Summary Actions
export const getGpsSummaryRequest = (filters = {}) => ({
    type: GET_GPS_SUMMARY_REQUEST,
    payload: { filters }
});

export const getGpsSummarySuccess = (summary) => ({
    type: GET_GPS_SUMMARY_SUCCESS,
    payload: { summary }
});

export const getGpsSummaryFailure = (err) => ({
    type: GET_GPS_SUMMARY_FAILURE,
    error: err
});

// GPS Report Actions
export const getGpsReportRequest = (filters = {}) => ({
    type: GET_GPS_REPORT_REQUEST,
    payload: { filters }
});

export const getGpsReportSuccess = (data) => ({
    type: GET_GPS_REPORT_SUCCESS,
    payload: { data }
});

export const getGpsReportFailure = (err) => ({
    type: GET_GPS_REPORT_FAILURE,
    error: err
});

// GPS Substatus Table Report Actions
export const getGpsSubstatusTableReportRequest = (filters = {}) => ({
    type: GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST,
    payload: { filters }
});

export const getGpsSubstatusTableReportSuccess = (data) => ({
    type: GET_GPS_SUBSTATUS_TABLE_REPORT_SUCCESS,
    payload: { data }
});

export const getGpsSubstatusTableReportFailure = (err) => ({
    type: GET_GPS_SUBSTATUS_TABLE_REPORT_FAILURE,
    error: err
});

// Tickets Summary Actions
export const getTicketsSummaryRequest = (filters = {}) => ({
    type: GET_TICKETS_SUMMARY_REQUEST,
    payload: { filters }
});

export const getTicketsSummarySuccess = (summary) => ({
    type: GET_TICKETS_SUMMARY_SUCCESS,
    payload: { summary }
});

export const getTicketsSummaryFailure = (err) => ({
    type: GET_TICKETS_SUMMARY_FAILURE,
    error: err
});

// Tickets Summary Graph Actions (independent for graph filters)
export const getTicketsSummaryGraphRequest = (filters = {}) => ({
    type: GET_TICKETS_SUMMARY_GRAPH_REQUEST,
    payload: { filters }
});

export const getTicketsSummaryGraphSuccess = (summary) => ({
    type: GET_TICKETS_SUMMARY_GRAPH_SUCCESS,
    payload: { summary }
});

export const getTicketsSummaryGraphFailure = (err) => ({
    type: GET_TICKETS_SUMMARY_GRAPH_FAILURE,
    error: err
});

// Simcards Report Actions
export const getSimcardsReportRequest = (filters = {}) => ({
    type: GET_SIMCARDS_REPORT_REQUEST,
    payload: { filters }
});

export const getSimcardsReportSuccess = (data) => ({
    type: GET_SIMCARDS_REPORT_SUCCESS,
    payload: { data }
});

export const getSimcardsReportFailure = (err) => ({
    type: GET_SIMCARDS_REPORT_FAILURE,
    error: err
});

// Devices Report Actions
export const getDevicesReportRequest = (filters = {}) => ({
    type: GET_DEVICES_REPORT_REQUEST,
    payload: { filters }
});

export const getDevicesReportSuccess = (data) => ({
    type: GET_DEVICES_REPORT_SUCCESS,
    payload: { data }
});

export const getDevicesReportFailure = (err) => ({
    type: GET_DEVICES_REPORT_FAILURE,
    error: err
});

// Devices Report Filtered Actions (for graph)
export const getDevicesReportFilteredRequest = (filters = {}) => ({
    type: GET_DEVICES_REPORT_FILTERED_REQUEST,
    payload: { filters }
});

export const getDevicesReportFilteredSuccess = (data) => ({
    type: GET_DEVICES_REPORT_FILTERED_SUCCESS,
    payload: { data }
});

export const getDevicesReportFilteredFailure = (err) => ({
    type: GET_DEVICES_REPORT_FILTERED_FAILURE,
    error: err
});

// Simcards Report Filtered Actions (for graph)
export const getSimcardsReportFilteredRequest = (filters = {}) => ({
    type: GET_SIMCARDS_REPORT_FILTERED_REQUEST,
    payload: { filters }
});

export const getSimcardsReportFilteredSuccess = (data) => ({
    type: GET_SIMCARDS_REPORT_FILTERED_SUCCESS,
    payload: { data }
});

export const getSimcardsReportFilteredFailure = (err) => ({
    type: GET_SIMCARDS_REPORT_FILTERED_FAILURE,
    error: err
});

// Agencies Actions
export const getAgenciesRequest = (filters = {}) => ({
    type: GET_AGENCIES_REQUEST,
    payload: { filters }
});

export const getAgenciesSuccess = (data) => ({
    type: GET_AGENCIES_SUCCESS,
    payload: { data }
});

export const getAgenciesFailure = (err) => ({
    type: GET_AGENCIES_FAILURE,
    error: err
});

// Companies Actions
export const getCompaniesReportsRequest = (filters = {}) => ({
    type: GET_COMPANIES_REPORTS_REQUEST,
    payload: { filters }
});

export const getCompaniesReportsSuccess = (data) => ({
    type: GET_COMPANIES_REPORTS_SUCCESS,
    payload: { data }
});

export const getCompaniesReportsFailure = (err) => ({
    type: GET_COMPANIES_REPORTS_FAILURE,
    error: err
});

// Export GPS Summary Actions
export const exportGpsSummaryRequest = (filters = {}, format = 'excel') => ({
    type: EXPORT_GPS_SUMMARY_REQUEST,
    payload: { filters, format }
});

export const exportGpsSummarySuccess = () => ({
    type: EXPORT_GPS_SUMMARY_SUCCESS
});

export const exportGpsSummaryFailure = (err) => ({
    type: EXPORT_GPS_SUMMARY_FAILURE,
    error: err
});

// Export Tickets Summary Actions
export const exportTicketsSummaryRequest = (filters = {}, format = 'excel') => ({
    type: EXPORT_TICKETS_SUMMARY_REQUEST,
    payload: { filters, format }
});

export const exportTicketsSummarySuccess = () => ({
    type: EXPORT_TICKETS_SUMMARY_SUCCESS
});

export const exportTicketsSummaryFailure = (err) => ({
    type: EXPORT_TICKETS_SUMMARY_FAILURE,
    error: err
});

// Export GPS Report Actions
export const exportGpsReportRequest = (filters = {}, format = 'excel') => ({
    type: EXPORT_GPS_REPORT_REQUEST,
    payload: { filters, format }
});

export const exportGpsReportSuccess = () => ({
    type: EXPORT_GPS_REPORT_SUCCESS
});

export const exportGpsReportFailure = (err) => ({
    type: EXPORT_GPS_REPORT_FAILURE,
    error: err
});

// Export Simcards Report Actions
export const exportSimcardsReportRequest = (filters = {}, format = 'excel') => ({
    type: EXPORT_SIMCARDS_REPORT_REQUEST,
    payload: { filters, format }
});

export const exportSimcardsReportSuccess = () => ({
    type: EXPORT_SIMCARDS_REPORT_SUCCESS
});

export const exportSimcardsReportFailure = (err) => ({
    type: EXPORT_SIMCARDS_REPORT_FAILURE,
    error: err
});

// Export Devices Report Actions
export const exportDevicesReportRequest = (filters = {}, format = 'excel') => ({
    type: EXPORT_DEVICES_REPORT_REQUEST,
    payload: { filters, format }
});

export const exportDevicesReportSuccess = () => ({
    type: EXPORT_DEVICES_REPORT_SUCCESS
});

export const exportDevicesReportFailure = (err) => ({
    type: EXPORT_DEVICES_REPORT_FAILURE,
    error: err
});

// Export Unified Inventory Report Actions
export const exportInventoryReportRequest = (filters = {}) => ({
    type: EXPORT_INVENTORY_REPORT_REQUEST,
    payload: { filters }
});

export const exportInventoryReportSuccess = () => ({
    type: EXPORT_INVENTORY_REPORT_SUCCESS
});

export const exportInventoryReportFailure = (err) => ({
    type: EXPORT_INVENTORY_REPORT_FAILURE,
    error: err
});

// Date Range Actions
export const SET_DATE_RANGE = "SET_DATE_RANGE";

export const setDateRange = (range, upToDate = null) => ({
    type: SET_DATE_RANGE,
    payload: { range, upToDate }
});

// Tickets Date Range Actions (startDate/endDate)
export const SET_TICKETS_DATE_RANGE = "SET_TICKETS_DATE_RANGE";

export const setTicketsDateRange = (range, startDate = null, endDate = null) => ({
    type: SET_TICKETS_DATE_RANGE,
    payload: { range, startDate, endDate }
});

// User Settings (saved filters per screen)
export const GET_USER_SETTINGS_REQUEST = "GET_USER_SETTINGS_REQUEST";
export const GET_USER_SETTINGS_SUCCESS = "GET_USER_SETTINGS_SUCCESS";
export const GET_USER_SETTINGS_FAILURE = "GET_USER_SETTINGS_FAILURE";

export const getUserSettingsRequest = (userId, screen) => ({
    type: GET_USER_SETTINGS_REQUEST,
    payload: { userId, screen }
});

export const getUserSettingsSuccess = (screen, settings) => ({
    type: GET_USER_SETTINGS_SUCCESS,
    payload: { screen, settings }
});

export const getUserSettingsFailure = (screen, err) => ({
    type: GET_USER_SETTINGS_FAILURE,
    payload: { screen },
    error: err
});

export const SAVE_USER_SETTINGS_REQUEST = "SAVE_USER_SETTINGS_REQUEST";
export const SAVE_USER_SETTINGS_SUCCESS = "SAVE_USER_SETTINGS_SUCCESS";
export const SAVE_USER_SETTINGS_FAILURE = "SAVE_USER_SETTINGS_FAILURE";

export const saveUserSettingsRequest = (userId, screen, filters) => ({
    type: SAVE_USER_SETTINGS_REQUEST,
    payload: { userId, screen, filters }
});

export const saveUserSettingsSuccess = (screen, settings) => ({
    type: SAVE_USER_SETTINGS_SUCCESS,
    payload: { screen, settings }
});

export const saveUserSettingsFailure = (screen, err) => ({
    type: SAVE_USER_SETTINGS_FAILURE,
    payload: { screen },
    error: err
});
